import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';
import { useLoaderStore } from '@/shared/store/useLoaderStore';

export const useCitySeoInfo = (
  citySlug: MaybeRefOrGetter<string>,
  currentTag: MaybeRefOrGetter<string>,
  page: MaybeRefOrGetter<number>,
  enabled: MaybeRefOrGetter<boolean>,
) => {
  const loaderStore = useLoaderStore();

  const { getSeoByCitySlugAndTag } = useExperienceApi();

  const {
    data: citySeoData,
    isSuccess,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: ['citySeoInfo', citySlug, currentTag, page],
    queryFn: async () => {
      const response = await getSeoByCitySlugAndTag({
        path: { citySlug: unref(citySlug) as string, currentTag: unref(currentTag) as string },
        query: { page: unref(page) as number },
      });

      loaderStore.check404(response);

      return response;
    },
    enabled: computed(() => !!unref(enabled)),
    placeholderData: (prev) => prev,
    select: (response) => response.data,
    retry: false,
  });

  return {
    isFetched,
    isSuccess,
    isFetching,
    citySeoData,
  };
};
